angular.module( 'angus.directives' ).directive( 'appMarginHistory', [
	'actionViewTemplates',
	function( actionViewTemplates ) {
		return {
			scope: {
				closeCb: "=",
				model: "=actionModel",
				settings: "=",
				widgetCode : "="
			},
			templateUrl: actionViewTemplates.marginHistoryReportContainer
		};
	}
] );